import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {AuthenticationService} from "@alfresco/adf-core";
import { algAuthorizationHeader } from '../alg-auth';

@Injectable({
  providedIn: 'root'
})
export class ProcessService {

  constructor(private http: HttpClient, private authService: AuthenticationService) {
  }

  getProcessesForCurrentUser(en_cours: boolean, offset: number, limit: number) {
    const endpointUrl = window.location.origin + '/alfresco/api/-default-/public/workflow/versions/1/processes';
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const username = (this.authService.getUsername() || '').replace(/['\\]/g, '\\$&');
    const params = new HttpParams()
      .set('where', `(startUserId='${username}' AND status='${en_cours ? 'active' : 'completed'}')`)
      .set('skipCount', offset)
      .set('maxItems', limit);
    return this.http.get(endpointUrl, {headers, params});
  }

  createProcess(body: any) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/processes/`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = {headers: headers};
    return this.http.post(endpointUrl, body, params);
  }

  postItemsToProcess(processId: string, items: any) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/processes/${processId}/items`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = {headers: headers};
    return this.http.post(endpointUrl, items, params);
  }

  getProcess(processId: any) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/processes/${processId}`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = {headers: headers};
    return this.http.get(endpointUrl, params);
  }

  getProcessVariables(processId: any) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/processes/${processId}/variables`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = {headers: headers};
    return this.http.get(endpointUrl, params);
  }

  getProcessItems(processId: any) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/processes/${processId}/items`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = {headers: headers};
    return this.http.get(endpointUrl, params);
  }

  getProcessDiagram(processId: any) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/workflow/versions/1/processes/${processId}/diagram`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = {headers: headers};
    return this.http.get(endpointUrl, params);
  }

  getProcessInstance(processId: string) {
    const endpointUrl = window.location.origin + `/alfresco/s/api/workflow-instances/activiti$${processId}?includeTasks=true`;
    let headers = new HttpHeaders();
    let auth = algAuthorizationHeader(this.authService)
    headers = headers.append('Authorization', auth);
    const params = {headers: headers};
    return this.http.get(endpointUrl, params);
  }
}
